
define(
	'Tavano.TT_GA4.Integration.Shopping.EntryPoint'
,   [
		'Tavano.TT_GA4.Integration.Shopping.Sync',
		'Backbone'	
	]
,   function (
		TavanoTT_GA4IntegrationShoppingSync,
		Backbone
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{

			/** @type {PDPComponent} */
			var pdpComponent = container.getComponent('PDP');
			/** @type {LayoutComponent} */
			var layoutComponent = container.getComponent('Layout');
			/** @type {EnvironmentComponent} */
			var environmentComponent = container.getComponent('Environment');
			/** @type {CartComponent} */
			var cartComponent = container.getComponent('Cart');

            layoutComponent.on('afterShowContent', function() {

                if (pdpComponent){
                    TavanoTT_GA4IntegrationShoppingSync.trackProductViewGA4(container);
                }
                
            });

			this.add_to_cart_quantity = 0;

			var self = this;

			cartComponent.on('beforeAddLine',function(lineToBeAdded){

				//setting quantity added to cart
				self.add_to_cart_quantity = lineToBeAdded && lineToBeAdded.line && lineToBeAdded.line.quantity || 0;
			
			})

			cartComponent.on('afterAddLine',function(lineAdded){

				//getting quantity added to cart
				var quantity = self.add_to_cart_quantity;
				//resetting quantity added to cart
				self.add_to_cart_quantity = 0;
				
				TavanoTT_GA4IntegrationShoppingSync.trackAddToCartGA4(container, lineAdded,  quantity);
				
			
			})


			

		}
	};
});
